import type { TaskListItem, TaskState } from './types';

export type TaskSegment = 'minhas' | 'equipe' | 'vencidas' | 'semprazo';

const OPEN_STATES: TaskState[] = ['Open', 'InProgress'];

/** True se a tarefa está em aberto (não concluída/cancelada). */
export function isOpenTask(t: TaskListItem): boolean {
  return OPEN_STATES.includes(t.state);
}

/** True se a tarefa tem prazo vencido e ainda está em aberto. */
export function isOverdue(t: TaskListItem, now: Date): boolean {
  return !!t.dueDateUtc && isOpenTask(t) && new Date(t.dueDateUtc) < now;
}

/**
 * Segmenta as tarefas nos 4 grupos do mock (TarefasView):
 * - minhas: do usuário atual, em aberto;
 * - equipe: todas;
 * - vencidas: com prazo vencido e em aberto;
 * - semprazo: sem prazo (qualquer estado).
 */
export function segmentTasks(
  tasks: TaskListItem[],
  meId: string | null,
  now: Date,
): Record<TaskSegment, TaskListItem[]> {
  return {
    minhas: tasks.filter((t) => meId != null && t.assigneeUserId === meId && isOpenTask(t)),
    equipe: tasks,
    vencidas: tasks.filter((t) => isOverdue(t, now)),
    semprazo: tasks.filter((t) => !t.dueDateUtc),
  };
}

export const SEGMENT_LABELS: Record<TaskSegment, string> = {
  minhas: 'Minhas tarefas abertas',
  equipe: 'Tarefas da equipe',
  vencidas: 'Vencidas',
  semprazo: 'Sem prazo',
};
